import _ from 'lodash'
import $ from 'jquery'
import appDisplay from 'scoreboard/components/app-display'
import BootslideClickableMenu from 'scoreboard/components/bootslide/bootslide-clickable-menu'
import Collapsible from 'scoreboard/components/collapsible'
import dependencyConfirmationPrompt from 'scoreboard/components/edit/dependency-confirmation-prompt'
import highlight from 'scoreboard/components/highlight'
import i18n from 'scoreboard/components/i18n'
import SingleFormfieldDialog from 'scoreboard/components/single-formfield-dialog'
import Tooltip from 'scoreboard/components/tooltip'

/**
 * @extends Collapsible
 */
const RollupTreeCollapsiblePanel = Collapsible.extend(/** @lends RollupTreeCollapsiblePanel.prototype */ {

	events: {
		'click .settings': 'onClickSettings'
	},

	onClickSettings(e) {
		let content = new BootslideClickableMenu({
			menuOptions: this.options.configMenuOptions
		})

		this.settingsTooltip = new Tooltip({
			attachTo: $(e.target),
			content,
			extraClass: 'has-bootslide-menu dataset-tree-rollup-tooltip'
		}).render()

		content.on('click', ({ e, handler }) => {
			_.invoke(this, handler, e)
		})
	},

	_onClickRename: function() {
		const form = new SingleFormfieldDialog({
			model: this.model,
			heading: i18n.get('common.edit2', this.labelKey),
			fieldLabel: 'common.name'
		})
		form.on('done', () => {
			this.$('.panel-header h3 .label').text(this.model.get('label'))
		})
		appDisplay.dialog(form)
	},

	_copy: function(label, model, url, eventModelFn) {
		let heading = i18n.get('common.copy.withArg', `<q>${_.escape(label)}</q>`)
		const copyDialog = new SingleFormfieldDialog({
			model,
			heading,
			fieldLabel: this.labelKey,
			primaryButtonLabel: 'common.copy',
			onSubmit: formData => {
				$.post({
					url,
					data: JSON.stringify(formData)
				}, response => {
					copyDialog.trigger('done')
					this.trigger('copy', eventModelFn(formData, response))
				})
			}
		})
		appDisplay.dialog(copyDialog)
	},

	/**
	 * @param {Event} e The event that triggered the deletion
	 *
	 * @param {KeySet|RollupTreeGroup} model
	 *
	 * @param {String} url The url to get the dependencies
	 *
	 * @param {String} [msgPrefixKey=''] A message to show regardless of
	 * whether there are any dependencies
	 *
	 * @param {String} [dependencyPrefixKey=''] An additional message to
	 * append before the list of dependencies
	 *
	 * @private
	 */
	_delete: function(e, model, url, msgPrefixKey = '', dependencyPrefixKeysByDomainType = {}) {
		e.stopPropagation()
		e.preventDefault()
		model.on('destroy', () => this.remove())
		dependencyConfirmationPrompt(url, model, dependencies => {
			return buildDependencyPromptOptions({
				model, msgPrefixKey, dependencyPrefixKeysByDomainType, dependencies
			})
		})
	}
})

function buildDependencyPromptOptions ({ model, msgPrefixKey,
	dependencyPrefixKeysByDomainType, dependencies }) {

	const label = highlight(model.get('label'))
	let overallMessagePrefix = i18n.get(msgPrefixKey, label)

	if (_.isEmpty(dependencies)) {
		return { messagePrefix: overallMessagePrefix }
	} else {
		let messagePrefixesAndLists = _(dependencies)
			.groupBy(d => d.domainType)
			.toPairs()
			.map(([domainType, list], i) => {
				let messagePrefix = ''
				if (i == 0) {
					messagePrefix += overallMessagePrefix + ' '
				}
				messagePrefix += i18n.get(dependencyPrefixKeysByDomainType[domainType], label)
				return { messagePrefix, list }
			})
			.value()
		return { messagePrefixesAndLists }
	}
}

export default RollupTreeCollapsiblePanel
export { buildDependencyPromptOptions }

RollupTreeCollapsiblePanel.__filename__ = 'admin/datasets/rollup-tree-collapsible-panel.js'
